export const CATEGORY_OPTIONS = [
  { label: 'myTickets.filterBar.categoryOption.allCategories', value: '' },
  {
    label: 'myTickets.filterBar.categoryOption.conflictOfInterest',
    value: 'conflict-of-interest',
  },
  {
    label: 'myTickets.filterBar.categoryOption.giftsAndDonations',
    value: 'gifts-and-donations',
  },
  {
    label: 'myTickets.filterBar.categoryOption.otherComplianceMatters',
    value: 'other-compliance-matters',
  },
  {
    label: 'myTickets.filterBar.categoryOption.employeeMovement',
    value: 'employee-movement',
  },
];

export const TICKET_STATUS_OPTIONS = [
  { label: 'myTickets.filterBar.ticketStatusOption.allStatus', value: '' },
  {
    label: 'myTickets.filterBar.ticketStatusOption.new',
    value: 'new',
  },
  {
    label: 'myTickets.filterBar.ticketStatusOption.inProgressPendingUser',
    value: 'in_progress_pending_user',
  },
  {
    label:
      'myTickets.filterBar.ticketStatusOption.inProgressPendingComplianceOfficer',
    value: 'in_progress_pending_compliance_officer',
  },
  {
    label: 'myTickets.filterBar.ticketStatusOption.pendingApprovals',
    value: 'pending_approvals',
  },
  {
    label: 'myTickets.filterBar.ticketStatusOption.pendingDagApproval',
    value: 'pending_dag_approval',
  },
  {
    label: 'myTickets.filterBar.ticketStatusOption.approved',
    value: 'approved',
  },
  {
    label: 'myTickets.filterBar.ticketStatusOption.approvedPendingSapDocument',
    value: 'approved_pending_sap_document',
  },
  {
    label: 'myTickets.filterBar.ticketStatusOption.notApproved',
    value: 'not_approved',
  },
  { label: 'myTickets.filterBar.ticketStatusOption.closed', value: 'closed' },
];

export const BUSINESS_UNIT_OPTIONS = [
  {
    label: 'myTickets.filterBar.businessUnitOption.allBusinessUnits',
    value: '',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.abInBevEfes',
    value: 'ABINBEV EFES',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buAndina',
    value: 'BU ANDINA',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buBeyondBeer',
    value: 'BU BEYOND BEER',
  },
  { label: 'myTickets.filterBar.businessUnitOption.buBnfl', value: 'BU BNFL' },
  {
    label: 'myTickets.filterBar.businessUnitOption.buBrazil',
    value: 'BU BRAZIL',
  },
  { label: 'myTickets.filterBar.businessUnitOption.buCac', value: 'BU CAC' },
  {
    label: 'myTickets.filterBar.businessUnitOption.buCanada',
    value: 'BU CANADA',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buCentralEurope',
    value: 'BU CENTRAL EUROPE',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buChina',
    value: 'BU CHINA',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buColombia',
    value: 'BU COLOMBIA',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buCrafts',
    value: 'BU CRAFTS',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buEastAfrica',
    value: 'BU EAST AFRICA',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buEastAsia',
    value: 'BU EAST ASIA',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buEcuador',
    value: 'BU ECUADOR',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buHondurasAndElSalvador',
    value: 'BU HONDURAS & EL SALVADOR',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buIndia',
    value: 'BU INDIA',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buMexico',
    value: 'BU MEXICO',
  },
  { label: 'myTickets.filterBar.businessUnitOption.buPeru', value: 'BU PERU' },
  {
    label: 'myTickets.filterBar.businessUnitOption.buRioDeLaPlata',
    value: 'BU RIO DE LA PLATA',
  },
  { label: 'myTickets.filterBar.businessUnitOption.buSea', value: 'BU SEA' },
  {
    label: 'myTickets.filterBar.businessUnitOption.buSoftDrinks',
    value: 'BU SOFT DRINKS',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buSouthAfrica',
    value: 'BU SOUTH AFRICA',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buSoutheast',
    value: 'BU SOUTHEAST',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buSoutheastAfrica',
    value: 'BU SOUTHEAST AFRICA',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buSouthernAfrica',
    value: 'BU SOUTHERN AFRICA',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buSupply',
    value: 'BU SUPPLY',
  },
  { label: 'myTickets.filterBar.businessUnitOption.buUsa', value: 'BU USA' },
  {
    label: 'myTickets.filterBar.businessUnitOption.buWestAfrica',
    value: 'BU WEST AFRICA',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buWestEurope',
    value: 'BU WEST EUROPE',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buZhqAfrica',
    value: 'BU ZHQ AFRICA',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buZhqAsia',
    value: 'BU ZHQ ASIA',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buZhqEurope',
    value: 'BU ZHQ EUROPE',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buZhqMiddleAmericas',
    value: 'BU ZHQ MIDDLE AMERICAS',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buZhqNorthAmerica',
    value: 'BU ZHQ NORTH AMERICA',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.buZhqSouthAmerica',
    value: 'BU ZHQ SOUTH AMERICA',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.coreGhq',
    value: 'CORE GHQ',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.globalCore',
    value: 'GLOBAL CORE',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.globalFunctions',
    value: 'GLOBAL FUNCTIONS',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.globalGrowth',
    value: 'GLOBAL GROWTH',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.globalServices',
    value: 'GLOBAL SERVICES',
  },
  {
    label: 'myTickets.filterBar.businessUnitOption.growthGroups',
    value: 'GROWTH GROUPS',
  },
];

export const ZONE_OPTIONS = [
  { label: 'myTickets.filterBar.zoneOption.allZones', value: '' },
  { label: 'myTickets.filterBar.zoneOption.global', value: 'GLO' },
  { label: 'myTickets.filterBar.zoneOption.southAmericaZone', value: 'SAZ' },
  {
    label: 'myTickets.filterBar.zoneOption.mexicoAndCentralAmericaZone',
    value: 'MAZ',
  },
  { label: 'myTickets.filterBar.zoneOption.africaZone', value: 'AFR' },
  { label: 'myTickets.filterBar.zoneOption.asiaPacificZone', value: 'APC' },
  { label: 'myTickets.filterBar.zoneOption.northAmericaZone', value: 'NAZ' },
  { label: 'myTickets.filterBar.zoneOption.europeZone', value: 'EUR' },
];

export const DATE_FORMAT_CONSTANTS = {
  DAY_START: 2,
  MONTH_START: 4,
  YEAR_START: 8,
  BASE_10: 10,
} as const;

export const UI_CONSTANTS = {
  LOADING_OPACITY: 0.6,
} as const;

export const ZONE_TO_BUSINESS_UNITS_MAPPING = {
  MAZ: [
    'myTickets.filterBar.businessUnitOption.buCac',
    'myTickets.filterBar.businessUnitOption.buColombia',
    'myTickets.filterBar.businessUnitOption.buEcuador',
    'myTickets.filterBar.businessUnitOption.buHondurasAndElSalvador',
    'myTickets.filterBar.businessUnitOption.buMexico',
    'myTickets.filterBar.businessUnitOption.buPeru',
  ],
  AFR: [
    'myTickets.filterBar.businessUnitOption.buEastAfrica',
    'myTickets.filterBar.businessUnitOption.buSouthAfrica',
    'myTickets.filterBar.businessUnitOption.buSouthernAfrica',
    'myTickets.filterBar.businessUnitOption.buSoutheastAfrica',
    'myTickets.filterBar.businessUnitOption.buWestAfrica',
  ],
  APC: [
    'myTickets.filterBar.businessUnitOption.buChina',
    'myTickets.filterBar.businessUnitOption.buEastAsia',
    'myTickets.filterBar.businessUnitOption.buIndia',
    'myTickets.filterBar.businessUnitOption.buSea',
  ],
  EUR: [
    'myTickets.filterBar.businessUnitOption.buBnfl',
    'myTickets.filterBar.businessUnitOption.buCentralEurope',
    'myTickets.filterBar.businessUnitOption.abInBevEfes',
    'myTickets.filterBar.businessUnitOption.buWestEurope',
  ],
  NAZ: [
    'myTickets.filterBar.businessUnitOption.buCanada',
    'myTickets.filterBar.businessUnitOption.buUsa',
  ],
  SAZ: [
    'myTickets.filterBar.businessUnitOption.buAndina',
    'myTickets.filterBar.businessUnitOption.buBrazil',
    'myTickets.filterBar.businessUnitOption.buRioDeLaPlata',
  ],
  GLO: ['myTickets.filterBar.zoneOption.global'],
} as const;
